import { Component, OnInit } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { RouterLink } from '@angular/router';
import { CustomizerSettingsService } from '../../customizer-settings/customizer-settings.service';
import { RapportService } from '../../services/rapport-service/rapport.service';
import { SampleService } from '../../services/sample-service/sample.service';

@Component({
    selector: 'app-total-revenue',
    standalone: true,
    imports: [MatCardModule, RouterLink],
    templateUrl: './total-revenue.component.html',
    styleUrl: './total-revenue.component.scss'
})
export class TotalRevenueComponent implements OnInit {

    // isToggled
    totalRapport = 0
    totalSamples : number = 0
    totalOt = 0
    isToggled = false;
ngOnInit(): void {
    this.getTotalRapport()
    this.getTotalOT()
}
    constructor(
        public themeService: CustomizerSettingsService,
        private rapportService:RapportService,
        private sampleService: SampleService
    ) {
        this.themeService.isToggled$.subscribe(isToggled => {
            this.isToggled = isToggled;
        });
    }
    // Dark Mode
    toggleTheme() {
        this.themeService.toggleTheme();
    }

    private getTotalRapport(){
        this.rapportService.total()
            .subscribe({
                next : res => this.totalRapport = res.data
            })
    }

    private getTotalOT(){
        this.sampleService.getSampleStatusCount().subscribe(statusCount => {
            this.totalOt = statusCount['Avec OT']; 
          });
    }
}